export enum ThermoE {
  COLD = 'COLD',
  WARM = 'WARM',
  COLD_WARM = 'COLD_WARM',
}
